import React, { useEffect, useState ,useContext, useMemo, useRef } from 'react';
import Header from './Header';
import BasketPreview from '../../Pages/BasketPreview';
import AppointmentSchedule from '../../Pages/AppointmentSchedule';
import Main from '../components/MainClass';
import { GlobalContext } from '../../utils/GlobalContext';
import RingBanner from './RingBanner';
import DiamondListPage from '../../Pages/DiamondListPage';

export const Index = () => {
    const { golbalClientDetails, category, updateLayerParams, client_code } = useContext(GlobalContext);
    const [ChangePage, setChangePage] = useState('RingBanner');
    const [loading, setLoading] = useState(true);
    const [clinetDetails, setclinetDetails] = useState([]);
    const [colorCodes, setColorCodes] = useState(['#00355D', '#d5b17f']);
    const [initialRingCategory, setInitialRingCategory] = useState('Most-Popular');
    const [initialSelectedItem, setInitialSelectedItem] = useState(null);
    const [initialMetalColor, setInitialMetalColor] = useState('White Gold');

    const handlePagesChanges = (page, ringCategory, selectedItem, metalColor) => {
        setChangePage(page);
        if (ringCategory) setInitialRingCategory(ringCategory);
        setInitialSelectedItem(selectedItem || null);
        if (metalColor) setInitialMetalColor(metalColor);
    };

    useEffect(() => {
        document.documentElement.style.setProperty('--color-theme', colorCodes[0]);
        document.documentElement.style.setProperty('--color-themetwo', colorCodes[1]);
    }, [colorCodes]);
    // Reading query parameters from the URL
    useEffect(() => {
      // Ensure golbalClientDetails is not null before attempting to access its properties
      if (golbalClientDetails) {
  
        // Check and set the client details, assuming it's an array and has at least one item
        if (golbalClientDetails.client_id && golbalClientDetails.client_id.length > 0) {
          setclinetDetails(golbalClientDetails.client_id[0]);
        }
  
        // Parse the color_code if available
        let clientDetailsData = golbalClientDetails.client_id[0];
        if (clientDetailsData && clientDetailsData.color_code) {
          const parsedColorCodes = clientDetailsData.color_code.split(',').map(c => c.trim()).filter(c => c !== '');
          if (parsedColorCodes.length >= 2) {
            const colors = [parsedColorCodes[0], parsedColorCodes[1]];
            console.log(colors);
            setColorCodes(colors);
            updateLayerParams('Color Code','color_code', colors);
          }
        }
        if(client_code == 'W284'){
            setChangePage('RingBanner');
        }else{
            setChangePage('Main');
        }
      }
    }, [golbalClientDetails]);

    return(
        <>
            <style>
                {`
                    @media only screen and (max-width: 950px) {
                        .mobile-sticky-wrapper {
                            display: block !important;
                        }
                        .mobile-preview-sticky {
                            position: -webkit-sticky !important;
                            position: sticky !important;
                            top: 0 !important;
                            z-index: 1000 !important;
                            background-color: white !important;
                            width: 100% !important;
                        }
                        .mobile-preview-sticky #viewer-container {
                            background-color: white !important;
                            margin: 0 !important;
                            padding: 10px !important;
                            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
                        }
                    }
                `}
            </style>
            <Header />
            {ChangePage == 'Main' ?(
                <section className='content'>
                    <Main
                        handlePagesChanges={handlePagesChanges}
                        initialRingCategory={initialRingCategory}
                        initialSelectedItem={initialSelectedItem}
                        initialMetalColor={initialMetalColor}
                    />
                </section>
            ):ChangePage == 'AppointmentSchedule' ?(
                <AppointmentSchedule
                    handlePagesChanges={handlePagesChanges}
                />
            ):ChangePage == 'BasketPreview' ?(
                <BasketPreview
                    handlePagesChanges={handlePagesChanges}
                />
            ):ChangePage =='RingBanner' ? (
                <RingBanner
                  handlePagesChanges={handlePagesChanges}
                  clinetDetails={clinetDetails}
                />
            ):ChangePage =='Diamond' ? (
                <DiamondListPage
                  account={client_code} // Replace with actual field if needed
                  criteria={'CardOption'}
                  totalDiamondsFound={0}
                  handlePagesChanges={handlePagesChanges}
                  colorCodes={colorCodes}
                />
            ):(
                <></>
            )}
        </>
    )
}

export default Index;